import { render, staticRenderFns } from "./GdbView.vue?vue&type=template&id=175dea29"
import script from "./GdbView.vue?vue&type=script&lang=ts"
export * from "./GdbView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports